<template>
  <div class="top">
    <div class="wrap_swiper">
      <slot></slot>
    </div>
    <div class="textWrap">
     <ul class="list">
        <li>GLOBE/TM 查话费发送1到222,查流量发送DATABAL到8080,或*143#拨号</li>
        <li>SMART/TNT/SUN 查话费流量*123#拨号出去，选择BAL</li>
        <li>DITO查话费流量，发送HELP到185 </li>
        <li>批量充值、订单问题、套餐咨询可联系人工客服</li>
      </ul>
    </div>
    <router-link :to="adv.url" v-if="adv">
      <div class="linkWrap">
        <img :src="adv.pic" alt="">
      </div>
    </router-link>

  </div>
</template>

<script>

  export default {
    name: "top",
    props: {
      adv: {
        type: Object,
        default: {}
      }
    },
    mounted() {
    },
    methods: {
      linkGoTo(url) {
        console.log(url);
        window.open(url, "_blank");
      }
    }
  }
</script>
<style scoped>
  .top {
    background: url(../../static/images/round.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: auto;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom:100px;

  }

  .top img {
    border-radius: 9px;
    width: 100%;
    height: auto;
    objectfill: cover;

  }

  .top .bannerWrap {
    margin-top: 10px;
    padding-left: 13px;
    padding-right: 13px;
  }

  .textWrap {
 /*   padding-left: 13px;
    padding-right: 13px; */
    color: #FFFFFF;
    text-align: left;
    font-size: 0.625rem;
    /* transform: scale(.9); */
    height: 1.5;
    line-height: 1.5;
  }
  .textWrap .list{
    list-style-type: none;
    text-align: left;
    padding-left: 13px;
    padding-right: 13px;
    height: 1.5;
    line-height: 1.5;
  }
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .linkWrap{
   margin:15px 13px 0;
  }
    .wrap_swiper{
    margin:15px 13px 0;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/top.vue